<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import NucleoWorkOrderRequestDistrictFields from './NucleoWorkOrderRequestDistrictFields.vue';
import NucleoWorkOrderRequestOnusFields from './NucleoWorkOrderRequestOnusFields.vue';

defineProps({
  errors: { type: Object, default: () => ({}) },
  form: { type: Object, required: true },
  sellers: { type: Array, default: () => [] },
  states: { type: Array, default: () => [] },
});
const emit = defineEmits([
  'setDistrictCount',
  'updateCondition',
  'updateDistrict',
]);
const { t } = useI18n();
const updateCondition = (...args) => emit('updateCondition', ...args);
const setDistrictCount = value => emit('setDistrictCount', value);
const updateDistrict = (...args) => emit('updateDistrict', ...args);
</script>

<template>
  <LaisCard
    :title="t('NUCLEO_WORK_ORDERS.REQUEST.CONDITIONS.TITLE')"
    prefix-icon="i-lucide-circle-help"
  >
    <p class="mb-5 text-sm text-lais-text-body">
      {{ t('NUCLEO_WORK_ORDERS.REQUEST.CONDITIONS.DESCRIPTION') }}
    </p>
    <div class="grid gap-6">
      <NucleoWorkOrderRequestOnusFields
        :errors="errors"
        :form="form"
        @update-condition="updateCondition"
      />
      <NucleoWorkOrderRequestDistrictFields
        :errors="errors"
        :form="form"
        :sellers="sellers"
        :states="states"
        @set-district-count="setDistrictCount"
        @update-condition="updateCondition"
        @update-district="updateDistrict"
      />
    </div>
  </LaisCard>
</template>
